exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.groupedfield[data-v-758429e6] {\n  border: 1px solid lightgrey;\n  padding: 5px;\n}\n.groupedfield__text[data-v-758429e6] {\n    font-weight: bold;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/fields/GroupField.vue"],"names":[],"mappings":";AACA;EACE,4BAA4B;EAC5B,aAAa;CACd;AACD;IACI,kBAAkB;CACrB","file":"GroupField.vue","sourcesContent":["\n.groupedfield[data-v-758429e6] {\n  border: 1px solid lightgrey;\n  padding: 5px;\n}\n.groupedfield__text[data-v-758429e6] {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-758429e6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/fields/GroupField.vue
// module id = dU4x
// module chunks = 72